import styled from 'styled-components';

export const ViewContainer = styled.div`
  margin-top: 20px;
  width: 500px;
`;

export const EditContestantsArea = styled.div`
  border-radius: 10px;
  width: 100%;
  padding: 16px;
  background-color: #fff;
  display: flex;
  align-items: center;
  height: 60px;
  cursor: pointer;
  gap: 20px;
`;

export const EditContestantsText = styled.div`
  color: #ff6a00;
  font-family: Space Grotesk;
  font-weight: 500;
`;

export const CustomSeedValue = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
`;

export const CustomSeedValueImage = styled.img`
  border-radius: 100%;
  width: 36px;
  height: 36px;
  object-fit: cover;
`;

export const CustomSeedValueText = styled.div`
  font-weight: 500;
`;

export const ContestantCard = styled.div`
  display: flex;
  align-items: center;
  padding: 8px;
  background: #fff;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f5f5f5;
  }
`;

export const Avatar = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin-right: 8px;
  object-fit: cover;
`;

export const ContestantName = styled.span`
  flex: 1;
  font-size: 14px;
  font-weight: 500;
  color: #000;
  margin-right: 8px;
`;

export const EditIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  opacity: 0.7;
  transition: opacity 0.2s;

  &:hover {
    opacity: 1;
  }
`;
